var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    _vm._b(
      {
        attrs: {
          method: "POST",
          target: "_blank",
          action: _setup.reverseFull({ name: "prg:prg" }),
        },
        on: {
          click: function ($event) {
            return _setup.emit("click")
          },
        },
      },
      "form",
      _vm.formAttrs,
      false
    ),
    [
      _c("input", {
        attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
        domProps: { value: _setup.context.csrf_token },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "url" },
        domProps: { value: _setup.encodedUrl },
      }),
      _vm._v(" "),
      _c(
        "button",
        _vm._b({ attrs: { type: "submit" } }, "button", _vm.buttonAttrs, false),
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }